<div class="app-alert__title bg-style color-light font-18 font-bold">
    {{ subtitles.setSubtitle(5129) }}
</div>

<div class="app-alert__close-alarm color-light font-14 cursor-pointer" (click)="appAlert.closePopup(key)">
    <img class="app-alert__close-alarm-img" src="/assets/img/icons/clear-button.svg" alt="Zamknij">
</div>

<div class="popup__container">
    <div class="app-alert__message font-15 cursor-default">
        {{ subtitles.setSubtitle(5168) + '. ' + subtitles.setSubtitle(5128) + ': ' }}
    </div>
    <div class="app-alert__link font-15 font-bold">
        <a class="link cursor-pointer" (click)="showDocumentPopup(LanguageShortcut.pl, 'policy')">
            Polski
        </a>
        <a class="link cursor-pointer" (click)="showDocumentPopup(LanguageShortcut.en, 'policy')">
            English
        </a>
        <a class="link cursor-pointer" (click)="showDocumentPopup(LanguageShortcut.de, 'policy')">
            Deutsch
        </a>
    </div>
    <input id="accept-policy" type="checkbox" [(ngModel)]="acceptPrivatePolicy">
    <label for="accept-policy" class="font-15 cursor-pointer">
        {{ subtitles.setSubtitle(5127) }}
    </label>
    <div class="app-alert__buttons-box">
        <button [disabled]="!acceptPrivatePolicy"
                [ngStyle]="{'background-color': acceptPrivatePolicy ? '#1cc501' : '#dddddd'}"
                class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
                (click)="popup.confirmPolicy(key)">
            {{ subtitles.setSubtitle(5130) }}
        </button>
    </div>
</div>